import React, { useEffect } from "react";
import "./LearningHubsNewContent.css";
import { CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { useDispatch } from "react-redux";
import { getLearnerCourses } from "Redux/CourseDetails";
import { getUserData } from "Redux/UserDetails";
import LearningHubsNewTabs from "./LearningHubsNewTabs";
import {
  isCourseEligible,
  getCoursesGroupedByCategoryAndModule,
} from "utils/foundationUnlock";
import { learnhubAssets } from "../../imagesData/ImagesData";
import useFetchImageUrls from "../../ConstantUseFetchImageUrls";

function LearningHubsNewContent() {
  const query = `params=${encodeURIComponent(JSON.stringify(learnhubAssets))}`;
  const { imageUrls, error } = useFetchImageUrls(query);

  const urls = imageUrls?.imageUrl || {};

  const { instance } = useMsal();
  const dispatch = useDispatch();
  const activeAccount = instance.getActiveAccount();
  const enterpriseId = activeAccount?.idTokenClaims?.enterpriseID;
  const userLevel = activeAccount.idTokenClaims?.jobFamilyDescription;

  useEffect(() => {
    if (!enterpriseId) return;

    dispatch(getLearnerCourses(enterpriseId));
    dispatch(getUserData(enterpriseId));
  }, [enterpriseId, dispatch]);

  const { coursesByHub } = useSelector((state) => state.courseDetails);
  const userData = useSelector((state) => state.userDetails.userData?.[0]);
  const courseLoader = useSelector((state) => state.courseDetails.loader);
  const userLoader = useSelector((state) => state.userDetails.loader);

  const isLoading = courseLoader || userLoader;

  const allHubs = coursesByHub || [];

  const completedEligibleCourses = allHubs.flatMap((hub) =>
    (hub.courses || []).filter((course) => course.completionDate)
  );

  const completedCoursesCount = completedEligibleCourses.length;

  let completedHubsCount = 0;

  allHubs.forEach((hub) => {
    const eligibleCoursesByCategoryAndModule =
      getCoursesGroupedByCategoryAndModule({
        coursesByHub: [hub],
        userData,
        userLevel,
        hubName: hub.hubName,
      });

    // Hub is completed if **all mandatory eligible courses in the hub are completed**
    const allMandatoryCourses = Object.values(
      eligibleCoursesByCategoryAndModule
    ) // categories
      .flatMap(
        (category) =>
          Object.values(category) // modules
            .flatMap((moduleObj) => moduleObj.Mandatory) // Mandatory courses
      );

    if (
      allMandatoryCourses.length &&
      allMandatoryCourses.every((c) => c.completionDate)
    ) {
      completedHubsCount += 1;
    }
  });

  // Total Hubs Count
  const totalHubsCount = allHubs.length;

  if (error) return <div>Error loading assets.</div>;
  if (!imageUrls || Object.keys(imageUrls).length === 0) return null;

  return (
    <>
      <div className="learning-hubs-wraper">
        <img
          //   src={
          //     process.env.PUBLIC_URL + "/Assets/Home/Ignite-banner2-latest.png"
          //   }
          src={urls["bannerLearnHub"]}
          alt="Ignite banner"
          className="banner-img"
        />
        <div className="ignite-banner-box">
          <div className="ignite-banner-content">
            <h1 className="banner-main-head">
              Step Into the Ignite Great Learning Carnival
            </h1>
            <p className="banner-sub-text">
              Your learning journey begins here. Start with the Core Learning
              Hub and progress through curated Learning Hubs designed to build
              relevant capabilities.
            </p>
          </div>
          <div className="banner-sub-content-row">
            <div className="banner-sub-content-box">
              <p>
                <span>Hub Details</span>
              </p>
              <p>{completedHubsCount} hubs completed</p>
            </div>
            <div className="banner-sub-content-box">
              <p>
                <span>Course Details</span>
              </p>
              <p>{completedCoursesCount} courses completed</p>
            </div>
          </div>
        </div>
      </div>
      {/* first section */}
      <div className="explore-learn-hub-section">
        <div className="explore-learn-hub-wrap">
          <h2 className="section-headings">Let's Explore Learning Hub!</h2>
          <p className="section-sub-text">
            Choose you next Hub, a Skill and then start learning and earning a
            new badge!
          </p>
        </div>
      </div>
      <div
        className="tabs-holder-wrap"
        style={{
          position: "relative",
          // position: "absolute",
          inset: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "rgba(255, 255, 255, 0.7)",
          zIndex: 10,
        }}
      >
        <LearningHubsNewTabs />

        {isLoading && (
          <div className="tabs-loader-overlay">
            <CircularProgress />
          </div>
        )}
      </div>
    </>
  );
}

export default LearningHubsNewContent;
